import { Tracker } from '@yoursurprise/segment-analytics';

const tracker = new Tracker();

export default tracker;
